export default {
    namespaced: true,
    state: {
        objs: []
    },
    actions: {
        getData({rootState}, params) {
            return new Promise((resolve, reject) => {
                let url = `${rootState.config.apiHost}coordinator-production?size=${params.size}&date=${params.date}&delivery_date=${params.delivery_date}`;
                this._vm.$axios.get(url,{headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response.data.data)
                    }, error => {
                        reject(error)
                    });
            })
        },
        save({rootState}, payload) {
            return new Promise((resolve, reject) => {
                let url = rootState.config.apiHost + "coordinator-production"
                this._vm.$axios.post(url, JSON.stringify(payload), {headers:{'Authorization': 'Bearer '+ rootState.token, 'Content-Type': 'application/json'}})
                    .then(response => {
                        resolve(response)
                    }, error => {
                        reject(error)
                    })
            })
        }
    }
}